import React, { useState } from "react";
import "./LabsSection.css";
import Roadmap from "./Roadmap";
import COEPillars from "./COEPillars";
import CollegeLabsPanel from "./CollegeLabsPanel";
import SchoolLabsPanel from "./SchoolLabsPanel";
import { FaSchool, FaGraduationCap, FaStar } from "react-icons/fa";

/* ── CoE Budget SVG Icons ── */
const IconLabSetup = () => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="14" height="14">
    <rect x="2" y="11" width="16" height="7" rx="1.5" stroke="#0e2a5a" strokeWidth="1.5"/>
    <rect x="5" y="7" width="10" height="5" rx="1" stroke="#0e2a5a" strokeWidth="1.4"/>
    <rect x="8" y="3" width="4" height="5" rx="1" stroke="#0e2a5a" strokeWidth="1.4"/>
    <line x1="10" y1="2" x2="10" y2="3" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
  </svg>
);

const IconEngineer = () => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="14" height="14">
    <circle cx="9" cy="7" r="3" stroke="#0e2a5a" strokeWidth="1.5"/>
    <path d="M3 17c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="#0e2a5a" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M15 3l1.5 1.5M17 6h-1.5" stroke="#0e2a5a" strokeWidth="1.3" strokeLinecap="round"/>
  </svg>
);

const IconRobot = () => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="14" height="14">
    <rect x="5" y="7" width="10" height="8" rx="2" stroke="#0e2a5a" strokeWidth="1.5"/>
    <rect x="8" y="3" width="4" height="4" rx="1" stroke="#0e2a5a" strokeWidth="1.4"/>
    <line x1="10" y1="7" x2="10" y2="7" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
    <circle cx="8" cy="11" r="1" fill="#0e2a5a"/>
    <circle cx="12" cy="11" r="1" fill="#0e2a5a"/>
    <line x1="8" y1="13" x2="12" y2="13" stroke="#0e2a5a" strokeWidth="1.2" strokeLinecap="round"/>
    <line x1="3" y1="10" x2="5" y2="10" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
    <line x1="15" y1="10" x2="17" y2="10" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
  </svg>
);

const IconKits = () => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="14" height="14">
    <rect x="3" y="6" width="14" height="11" rx="2" stroke="#0e2a5a" strokeWidth="1.5"/>
    <path d="M7 6V5a3 3 0 0 1 6 0v1" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
    <line x1="10" y1="10" x2="10" y2="13" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
    <line x1="8.5" y1="11.5" x2="11.5" y2="11.5" stroke="#0e2a5a" strokeWidth="1.4" strokeLinecap="round"/>
  </svg>
);

const IconMaintenance = () => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="14" height="14">
    <path d="M14.5 3.5a3 3 0 0 1 0 4.24l-8 8a3 3 0 1 1-4.24-4.24l8-8A3 3 0 0 1 14.5 3.5z" stroke="#0e2a5a" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="4.5" cy="15.5" r="1" fill="#0e2a5a"/>
  </svg>
);

export default function LabsSection() {
  const [active, setActive] = useState(null);

  return (
    <section className="labs-section">
      {/* ===== TABS ===== */}
      <div className="labs-tabs-wrapper">
        <div className="tab-box">
          <button
            className={`tab ${active === "school" ? "active" : ""}`}
            onClick={() => setActive("school")}
          >
            <FaSchool /> School →
          </button>
        </div>
        <div className="tab-box">
          <button
            className={`tab ${active === "college" ? "active" : ""}`}
            onClick={() => setActive("college")}
          >
            <FaGraduationCap /> College →
          </button>
        </div>
        <div className="tab-box">
          <button
            className={`tab ${active === "coe" ? "active" : ""}`}
            onClick={() => setActive("coe")}
          >
            <FaStar /> Centre of Excellence →
          </button>
        </div>
      </div>

      {/* ================= SCHOOL ================= */}
      {active === "school" && (
        <SchoolLabsPanel onClose={() => setActive(null)} />
      )}

      {/* ================= COLLEGE ================= */}
      {active === "college" && (
        <CollegeLabsPanel onClose={() => setActive(null)} />
      )}

      {/* ================= COE ================= */}
      {active === "coe" && (
        <div className="coe-section">
          <div className="coe-header">
            <div className="coe-badge">
              <FaStar /> Centre of Excellence
            </div>
            <div className="coe-breadcrumb">
              iBots / Protowiz Private Limited · Full Lab Setup & Operations
            </div>
          </div>

          <div className="coe-stats">
            <div className="coe-item">
              <h4>ONE-TIME SETUP</h4>
            </div>
            <div className="coe-item">
              <h2>30</h2>
              <p>DAYS TO LAUNCH</p>
            </div>
            <div className="coe-item">
              <h2>50+</h2>
              <p>STUDENTS / BATCH</p>
            </div>
            <div className="coe-item">
              <h2>6 Mo.</h2>
              <p>ENGINEER ON-SITE</p>
            </div>
            <div className="coe-item">
              <h2>1 Yr</h2>
              <p>EQUIPMENT WARRANTY</p>
            </div>
          </div>

          <div className="coe-details">
            <div className="coe-delivers">
              <div className="section-header">
                <span className="green-dot" />
                <h4>WHAT THIS DELIVERS</h4>
                <span className="badge">5 KEY OUTCOMES</span>
              </div>
              <div className="deliver-card">
                <strong>Fully Branded Innovation Lab</strong>
                <p>Turnkey setup equipped & commissioned in <b>30 days</b>.</p>
              </div>
              <div className="deliver-card">
                <strong>7 Demo Robots + 20 Training Kits</strong>
                <p>Across <b>5 technology domains</b>.</p>
              </div>
              <div className="deliver-card">
                <strong>Resident Innovation Engineer</strong>
                <p>On-site for <b>6 months</b>.</p>
              </div>
              <div className="deliver-card">
                <strong>Accreditation & Research Support</strong>
                <p>Boosts <b>NBA, NAAC</b> scores.</p>
              </div>
              <div className="deliver-card">
                <strong>Ongoing Expert Sessions</strong>
                <p><b>Bi-annual</b> workshops.</p>
              </div>
              <div className="deliver-footer">
                End-to-end implementation & support by iBots
              </div>
            </div>

            <div className="coe-budget">
              <div className="section-header">
                <span className="blue-dot" />
                <h4>BUDGET BREAKDOWN</h4>
              </div>

              <div className="budget-item">
                <span className="budget-label">
                  <span className="budget-icon"><IconLabSetup /></span>
                  Lab Setup &amp; Infrastructure
                </span>
                <div className="bar blue" style={{ width: "50%" }} />
                <p>50%</p>
              </div>

              <div className="budget-item">
                <span className="budget-label">
                  <span className="budget-icon"><IconEngineer /></span>
                  Innovation Engineer (6 months)
                </span>
                <div className="bar blue" style={{ width: "25%" }} />
                <p>25%</p>
              </div>

              <div className="budget-item">
                <span className="budget-label">
                  <span className="budget-icon"><IconRobot /></span>
                  Demo Robots — 7 units
                </span>
                <div className="bar green" style={{ width: "15%" }} />
                <p>15%</p>
              </div>

              <div className="budget-item">
                <span className="budget-label">
                  <span className="budget-icon"><IconKits /></span>
                  Training Kits — 20 units
                </span>
                <div className="bar green" style={{ width: "10%" }} />
                <p>10%</p>
              </div>

              <div className="maintenance">
                <span className="budget-label">
                  <span className="budget-icon"><IconMaintenance /></span>
                  Annual Maintenance
                </span>
                <strong>&#8377;1L <small>approx / yr</small></strong>
              </div>

              <div className="total-box">
                Total One-Time Investment <span>&#8377;10L</span>
              </div>
            </div>
          </div>

          <Roadmap />
          <COEPillars />
        </div>
      )}
    </section>
  );
}